import { Injectable, Injector } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { usesFootballerAuth } from "./footballer-auth.service";

@Injectable({
  providedIn: "root"
})
export class AuthRedirectService {
  public static readonly redirectStartedKey = "nogosh.auth.redirect.startedAt";

  constructor(private injector: Injector) {}

  public login(targetUrl?: string) {
    this.markRedirectStarted();
    return this.auth().loginWithRedirect({
      appState: targetUrl ? { target: targetUrl } : undefined,
      authorizationParams: {
        ui_locales: this.auth0UiLocales()
      }
    });
  }

  public signup(targetUrl?: string) {
    this.markRedirectStarted();
    return this.auth().loginWithRedirect({
      appState: targetUrl ? { target: targetUrl } : undefined,
      authorizationParams: {
        ui_locales: this.auth0UiLocales(),
        screen_hint: "signup",
        prompt: "login",
        action: "signup",
        mode: "signUp"
      } as any
    });
  }

  public passwordMigration(targetUrl?: string, parameters?: { [key: string]: string }) {
    this.markRedirectStarted();
    return this.auth().loginWithRedirect({
      appState: targetUrl ? { target: targetUrl } : undefined,
      authorizationParams: {
        ui_locales: this.auth0UiLocales(),
        connection: parameters && parameters.connection
          ? parameters.connection
          : "Username-Password-Authentication",
        screen_hint: "signup",
        prompt: "login",
        action: "signup",
        mode: "signUp"
      } as any
    });
  }

  private auth(): AuthService {
    return this.injector.get(AuthService);
  }

  private markRedirectStarted(): void {
    if (usesFootballerAuth) return;
    try {
      sessionStorage.setItem(AuthRedirectService.redirectStartedKey, Date.now().toString());
    } catch (_) {
    }
  }

  private auth0UiLocales(): string {
    return this.resolveLanguage() === "hr" ? "hr en" : "en";
  }

  private resolveLanguage(): string {
    if (document.documentElement.lang === "hr") {
      return "hr";
    }

    const cachedLanguage = this.cachedLanguage();
    if (cachedLanguage === "hr") {
      return "hr";
    }

    const browserLanguages = typeof navigator !== "undefined" && navigator.languages
      ? navigator.languages
      : [];

    return browserLanguages.some((language) => language && language.toLowerCase().indexOf("hr") === 0)
      ? "hr"
      : "en";
  }

  private cachedLanguage(): string {
    try {
      const publicLanguage = localStorage.getItem("nogosh.locale.public");
      if (publicLanguage) {
        return publicLanguage;
      }

      const localeKey = Object.keys(localStorage)
        .find((key) => key.indexOf("nogosh.locale.") === 0);

      return localeKey ? localStorage.getItem(localeKey) : "";
    } catch (_) {
      return "";
    }
  }
}
